/** Modules unlocked in Vite dev without changing Mongo user permissions. */
const LOCAL_DEV_BYPASS_MODULES = new Set([
  "missions",
  "mission_control",
  "clients",
  "artifacts",
  "calculators",
  "case_checking",
]);

export function normalizeModuleId(module: string): string {
  return module.toLowerCase().replace(/-/g, "_");
}

/** True when local frontend dev should treat the module as granted. */
export function localDevBypassesModule(module: string): boolean {
  if (!import.meta.env.DEV) {
    return false;
  }
  return LOCAL_DEV_BYPASS_MODULES.has(normalizeModuleId(module));
}
